import { ActivatedRouteSnapshot } from '@angular/router';

import { Submission } from '../../../submissions/next/models';
import { submittedDocsTokenizer } from '@data-access/documents/token/document.token';
import { inject } from '@angular/core';
import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { CONFIGURE_DEFAULT_PARAMS, LoadGridPayload } from '@data-access/shared';

export const workspaceDocumentResolver = (route: ActivatedRouteSnapshot) => {
  const _submission = route.parent?.data['submission'] as Submission;
  if (!_submission) {
    throw new Error('Submission not found in parent route data');
  }

  const _wcgTableUtils = inject(WcgTableUtilsService);
  let _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );
  _params = _params.set('filter_by', 'all');
  const taskId = route.queryParamMap.get('taskId');
  if (taskId) {
    _params = _params.set('task_instance_id', taskId);
  }
  const _payload: LoadGridPayload = {
    params: _params,
  };

  const _submittedDocumentSignalStore = submittedDocsTokenizer();
  _submittedDocumentSignalStore.setWorkspaceId(_submission?.id);
  _submittedDocumentSignalStore.setWorkspaceIntId(
    _submission?.int_id?.toString() ?? '',
  );
  _submittedDocumentSignalStore.loadDocumentTypes({
    workspaceId: _submission?.id,
  });
  _submittedDocumentSignalStore.loadSDGrid(_payload);
  return true;
};
